import { isRequiredCurrency } from 'utils/validators';

export const validate = values => {
  const errors = {};

  if (isRequiredCurrency(values)) {
    errors['USD'] = 'Error';
    errors['EUR'] = 'Error';
    errors['NOK'] = 'Error';
    errors['_error'] =
      'Value for at least one currency for each category should be filled in';
  }

  return errors;
};

export const dailyValidate = values => {
  const errors = {};

  if (values.days && values.days.length) {
    const days = values.days;
    const daysArrayErrors = [];

    days.forEach((day, dayIndex) => {
      const dayErrors = {};

      if (isRequiredCurrency(day)) {
        dayErrors['USD'] = 'Error';
        dayErrors['EUR'] = 'Error';
        dayErrors['NOK'] = 'Error';
        dayErrors['error'] =
          'Value for at least one currency for each category should be filled in';
        daysArrayErrors[dayIndex] = dayErrors;
      }
    });

    if (daysArrayErrors.length) {
      errors.days = daysArrayErrors;
      errors.days = { ...daysArrayErrors, _error: { ...daysArrayErrors } };
      errors['_error'] = { ...daysArrayErrors };
    }
  }

  return errors;
};
